import { uniqueId } from 'lodash';

import { Tag, TagAttributes } from 'dashboard/models/tag';
import { ApiModel } from 'lib/interfaces/api';

export const generateTagId = () => uniqueId('tag_');

export function createMockTag(attributes?: Partial<TagAttributes>, id?: string): Tag {
  return {
    id: id || generateTagId(),
    type: ApiModel.Tag,
    attributes: {
      name: 'some-tag-name',
      status: 'active',
      'created-at': '1994-12-30T12:30:00.000Z',
      'updated-at': '1994-12-30T12:30:00.000Z',
      ...attributes,
    },
  };
}
